import LTR from "@brand-icons/ploom/lock-outline-close/lock-outline-close-ltr.svg";

import { iconFactory } from "../iconFactory";

export const LockOutlineCloseIcon = iconFactory("LockOutlineCloseIcon", LTR);
